module.exports = __webpack_public_path__ + "static/click_heatmap_landing-4e92e06052077cc8f3f8c7ea066fae70.jpg";